import * as module from 'rrule'

// La bibliothèque rrule publie un module CommonJS pour Node et un module ESM pour les
// empaqueteurs : sous Node, les exports nommés ne sont visibles que via « default ».
type ModuleRrule = typeof module
const rrule: ModuleRrule =
  'rrulestr' in module && typeof module.rrulestr === 'function'
    ? module
    : (module as unknown as { default: ModuleRrule }).default

export const rrulestr = rrule.rrulestr
